import React, { Component } from 'react';
import { Grid } from '@material-ui/core';
import { SofaFormControl, SofaLink } from '@sofology/sofologycomponents';

import './FinancePersonalDetailsForm.scss';

import { SofaFormComponent } from 'interfaces';
import { IlpQuestionDescriptions, IfcApplicationData, SofaFormCrossValidationHandlerType } from 'models';
import { componentGeneratorHelper, formGeneratorHelper, PropertyValueType, SofaFormType } from 'helpers/dynamicFormHelpers';

const CUSTOMER_FORM_NAME = 'customer';

interface OwnProps {
    ifcQuestionSet: IlpQuestionDescriptions;
    ifcApplicationData: IfcApplicationData;
    ref?: React.RefObject<FinancePersonalDetailsFormType>;
    onGoToStartCheckout: () => void;
    onDynamicFormInitialized: () => void;
}

interface OwnState {
    customerForm: SofaFormType;
    proccessFormCrossValidation: SofaFormCrossValidationHandlerType;
    formHasInvalidReadonlyControls: boolean;
}

class FinancePersonalDetailsForm extends Component<OwnProps, OwnState> implements SofaFormComponent<Record<string, PropertyValueType>> {
    constructor(props: OwnProps) {
        super(props);

        let customerForm = formGeneratorHelper.createSofaForm(
            'customerForm',
            this.props.ifcQuestionSet[CUSTOMER_FORM_NAME].properties,
            (updateStateFunc: any) => this.setState(updateStateFunc),
            () => this.state,
            this.props.ifcApplicationData
        );

        this.state = {
            customerForm: customerForm.form,
            formHasInvalidReadonlyControls: false,
            proccessFormCrossValidation: customerForm.crossValidationHandler
        };
    }

    componentDidMount(): void {
        formGeneratorHelper.validateReadonlyControls(this.props.ifcQuestionSet[CUSTOMER_FORM_NAME].properties, this.state.customerForm)
            .then(invalidControls => {
                if (invalidControls.length) {
                    this.setState({ formHasInvalidReadonlyControls: true }, () => {
                        this.props.onDynamicFormInitialized();
                    });
                }
            }).catch();
    }

    componentDidUpdate(prevProps: Readonly<OwnProps>, prevState: Readonly<OwnState>): void {
        this.state.proccessFormCrossValidation(prevState, this.state);
    }

    render() {
        return (
            <div className='finance-personal-details-form'>
                {this.renderForm()}
            </div>
        );
    }

    renderForm(): JSX.Element {
        const { ifcQuestionSet, ifcApplicationData } = this.props;
        const { customerForm, formHasInvalidReadonlyControls } = this.state;
        const customerFieldSet = ifcQuestionSet[CUSTOMER_FORM_NAME];

        let formComponents: JSX.Element[] = [];

        if (customerForm) {
            formComponents = componentGeneratorHelper.getComponents(customerForm, customerFieldSet.properties, ifcApplicationData);
        }

        return (
            <div className='finance-personal-details-form__form'>
                <Grid container spacing={3}>
                    {formHasInvalidReadonlyControls && this.renderInvalidReadonlytFieldMessage()}
                    <Grid item xs={12}>
                        <h6 className='finance-personal-details-form__form__title'>
                            {customerFieldSet.legend}
                        </h6>
                    </Grid>
                    {formComponents}
                </Grid>
            </div>
        );
    }

    renderInvalidReadonlytFieldMessage(): JSX.Element {
        return (
            <Grid item xs={12}>
                <div className='finance-personal-details-form__readonly-fields-error'>
                    Previously saved information is missing mandatory fields or contains invalid characters.
                    <SofaLink onClick={this.props.onGoToStartCheckout} text='Please go back and enter manually' />
                </div>
            </Grid>
        );
    }

    public validate = (): Promise<SofaFormControl<Record<string, PropertyValueType>>[]> => {
        return this.state.customerForm.validate();
    };

    public getFormData = (): Record<string, PropertyValueType> => {
        return formGeneratorHelper.extractFormDataToIlpObject(
            this.state.customerForm,
            this.props.ifcQuestionSet[CUSTOMER_FORM_NAME].properties);
    };

    public hasInvalidReadonlyControls = (): boolean => {
        return this.state.formHasInvalidReadonlyControls;
    };
}

export default (FinancePersonalDetailsForm);
export type FinancePersonalDetailsFormType = FinancePersonalDetailsForm;